<template>
  <PageContainer>
    <div class="page-content">
      <div class="title animated"
        v-html="this.formatQuestionText(this.question.question_text)" />

      <div class="button-multi-select" v-for="(option, index) in questionOptions" :key="index">
        <label :for="'opt_' + index">
          <input type="checkbox" :id="'opt_' + index" :value="option.answer_text" v-model="optionsSelection">
          <span style="line-height: 18px" v-html="formatAnswerText(option.answer_text || '', 'option-wrap', 'p-smaller')"></span>
        </label>
      </div>

      <textarea
        maxlength="300"
        v-if="isOtherSelected"
        v-model="customOption"
        class="form-control other-textarea"
        name="personal-opinion"
        cols="30"
        rows="6"
        placeholder="Type..."
      ></textarea>
    </div>

    <div class="footer-container">
      <ButtonNext class="slide-down" :onClick="next" :isDisabled="!optionsSelection.length" :text="'Next'" />
      <ProgressBar />
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '../../shared/components/PageContainer';
import ButtonNext from '../../shared/components/ButtonNext';
import ProgressBar from '../../shared/components/ProgressBar';
import { navigateTo, ROUTE_NAMES } from '../router';
import Trackeable from '../../Trackeable';
import ProgressFull from '../mixins/ProgressFull';
import { formatQuestionTextInParenthesis, formatAnswerTextInParenthesis } from '../../shared/utils';

const otherValues = ['Other', 'Another method not listed'];

export default {
  name: 'WeightLossProgramTried3',
  components: {
    PageContainer,
    ButtonNext,
    ProgressBar
  },
  mixins: [Trackeable, ProgressFull],
  data() {
    const { $store } = this;
    const question = $store.getters.getQuestion('triedProgramSelection3');
    const questionOptions = $store.getters.getOptions('triedProgramSelection3');
    return {
      optionsSelection: [],
      question,
      questionOptions,
      customOption: null
    }
  },
  computed: {
    isOtherSelected: function() {
      const { optionsSelection } = this;
      return otherValues.some(o => optionsSelection.includes(o));
    }
  },
  methods: {
    next() {
      const { customOption, optionsSelection, $router, $store } = this;
      if (otherValues.some(o => optionsSelection.includes(o)) && !customOption) {
        return;
      }
      $store.commit('updateAnswers', { triedProgramSelection3: optionsSelection })
      if (customOption) {
        $store.commit('updateAnswers', { triedProgramSelection3Custom: customOption })
      } else {
        $store.commit('updateAnswers', { triedProgramSelection3Custom: undefined })
      }
      navigateTo($router, ROUTE_NAMES.WeightHistory);
    },
    formatQuestionText: formatQuestionTextInParenthesis,
    formatAnswerText: formatAnswerTextInParenthesis
  }
}
</script>
